import { useEffect, useRef } from 'react';
import noop from 'lodash/noop';

const useInterval = (
  callback: (payload: any) => any = noop,
  delay: null | number = null,
) => {
  const savedCallback = useRef(noop);

  useEffect(
    () => {
      savedCallback.current = callback;
    },
    [callback],
  );

  useEffect(
    () => {
      const tick = () => {
        savedCallback.current();
      };

      if (delay !== null) {
        const id = setInterval(tick, delay);
        return () => {
          clearInterval(id);
        };
      }
      return noop;
    },
    [delay],
  );
};

export default useInterval;
